import { initialState } from "./state"

export default {
  updateLoading: (state, payload) => (state.loading = payload),
  setIsEditing: (state, payload) => (state.isEditing = payload),
  setIsComingFromSchedule: (state, payload) =>
    (state.isComingFromSchedule = payload),
  setFlow: (state, payload) => (state.flow = payload),
  setSkipCoverage: (state, payload) => (state.skipCoverage = payload),
  setSkipCredit: (state, payload) => (state.skipCredit = payload),
  setSkipBiometry: (state, payload) => (state.skipBiometry = payload),
  setSaleToEditId: (state, payload) => (state.saleToEditId = payload),
  setSelectedOfferId: (state, payload) => (state.selectedOfferId = payload),
  setOrigin: (state, payload) => (state.origin = payload),
  setSaleId: (state, payload) => (state.saleId = payload),
  setSaleCode: (state, payload) => (state.saleCode = payload),
  setSaleDate: (state, payload) => (state.saleDate = payload),
  setSaleHistory: (state, payload) => (state.saleHistory = payload),
  setSaleSeller: (state, payload) => (state.saleSeller = payload),
  setSaleUuid: (state, payload) => (state.uuid = payload),
  setSaleStatus: (state, payload) => (state.status = payload),
  setCoverageStatus: (state, payload) => (state.coverageStatus = payload),
  setSaleSubStatus: (state, payload) => (state.subStatus = payload),
  setSaleItemUuid: (state, payload) => (state.saleItemUuid = payload),
  setQRCode: (state, payload) => (state.qrcode = payload),
  setFromVisit: (state, payload) => (state.fromVisit = payload),
  setRules: (state, payload) => (state.rules = payload),
  setDataToTransform: (state, payload) => (state.dataToTransform = payload),
  setNote: (state, payload) => (state.note = payload),
  setDeactivatedEditFlowToUse: (state, payload) => state.deactivatedEditFlowToUse = payload,
  setBePeopleSearch: (state, payload) => state.bePeopleSearch = payload,
  setAllowAddResponsible: (state, payload) => (state.allowAddResponsible = payload),
  setBlockDuplicatedCustomerContacts: (state, payload) => (state.blockDuplicatedCustomerContacts = payload),
  setOnlyQualifiedResponsibles: (state, payload) => (state.onlyQualifiedResponsibles = payload),
  resetSale: state => {
    const init_state = initialState()
    const keysToKeep = [
      'providerSaleFlows', 
      'hasCaptation',
      'hasCtos', 
      'canMovePin', 
      'hasToChangeFlowByRole', 
      'bePeopleSearch',
      'allowAddResponsible', 
      'onlyQualifiedResponsibles',
      'blockDuplicatedCustomerContacts'
    ]
    Object.keys(state).forEach(key => {
      if (keysToKeep.includes(key)) {
        return
      }
      state[key] = init_state[key]
    })
  },
  setProviderSaleFlows: (state, payload) => (state.providerSaleFlows = payload),
  setSelectedRoutes: (state, payload) => (state.selectedRoutes = payload),
  setSelectedProviderSaleFlow: (state, payload) => (state.selectedProviderSaleFlow = payload),
  setHasCaptation: (state, payload) => (state.hasCaptation = payload),
  setHasCtos: (state, payload) => (state.hasCtos = payload),
  setCanMovePin: (state, payload) => (state.canMovePin = payload),
  setHasToChangeFlowByRole: (state, payload) => (state.hasToChangeFlowByRole = payload),
  setPersonType(state, payload) {
    state.personType = payload
  }
}
